export const learnModePresetsMenu = [
  { label: "Default", value: "default" },
  { label: "Low", value: "low" },
  { label: "Med", value: "med" },
  { label: "High", value: "high" },
  { label: "Extreme", value: "extreme" },
  { label: "---", value: "---" },
];

export const learnModePresets = [
  {
    name: "default",
    sensitivity: 1,
    threshold: 1,
    crosstalkThreshold: 5,
  },
  {
    name: "low",
    sensitivity: 0.8,
    threshold: 1.25,
    crosstalkThreshold: 7,
  },
  {
    name: "med",
    sensitivity: 0.9,
    threshold: 1.1,
    crosstalkThreshold: 6,
  },
  {
    name: "high",
    sensitivity: 1.1,
    threshold: 0.9,
    crosstalkThreshold: 5,
  },
  {
    name: "extreme",
    sensitivity: 1.25,
    threshold: 0.75,
    crosstalkThreshold: 4,
  },
  {
    name: "---",
    sensitivity: null,
    threshold: null,
    crosstalkThreshold: null,
  },
];
